import { lt } from '@mews/framework';
import { EmptyStateProps, Stack, Table, TableProvider, useTableState } from '@optimus-web/core';
import { DocumentsTableHead } from './DocumentsTableHead';
import { useDocumentsTableColumns } from './hooks/useDocumentsTableColumns';
import { DocumentsTableRowData } from './types';
import { useReservationContracts } from './hooks/useReservationContracts';
import { useDocumentsTableContext } from './DocumentsTableContext';

export const DocumentsTable = () => {
    const columns = useDocumentsTableColumns();
    const [tableState, setTableState] = useTableState<DocumentsTableRowData>({
        pagination: { show: false },
    });
    const { groupId, reservationId } = useDocumentsTableContext();
    const contracts = useReservationContracts({ groupId, reservationId });

    const emptyStateMessage: EmptyStateProps = {
        primaryText: <></>,
        secondaryText: lt('ContractsTableNoDocumentsSecondaryText'),
    };

    return (
        <Stack spacing="200" vertical>
            <DocumentsTableHead />
            <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
                <Table
                    fixedFirstColumn
                    uniqueRowId="id"
                    data={contracts ?? []}
                    amountOfRows={contracts?.length ?? 0}
                    emptyState={emptyStateMessage}
                />
            </TableProvider>
        </Stack>
    );
};
